import { faCircleCheck } from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TooltipMU } from "app/components/tooltip/TooltipMU"
import React, { useCallback, memo } from "react"

const estiloOrcamentoConcluido = require("./orcamento-concluido.module.scss").default

const estiloIcone: React.CSSProperties = { color: "#5ac93c", marginRight: "8px" }
const estiloTitulo: React.CSSProperties = { fontWeight: 700 }

export type OrcamentoConcluidoProps = {
    numero: number
    descricaoSituacao: string
    numeroDav: string
    onImprimirOrcamento: () => void
    onNovoOrcamento: () => void
    onClickNumeroOrc: () => void
    permitidoImprimir: boolean
    aptoParaCheckoutMovel: boolean
    processando?: boolean
}

export const OrcamentoConcluido = memo((props: OrcamentoConcluidoProps) => {
    const handleNovoOrcamento = useCallback(() => {
        props.onNovoOrcamento()
    }, [props.onNovoOrcamento])

    const handleClickNumeroOrc = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault()

        if (!props.processando) {
            props.onClickNumeroOrc()
        }
    }, [props.onClickNumeroOrc, props.processando])

    return (
        <div className={estiloOrcamentoConcluido.conteudo}>
            <div className={estiloOrcamentoConcluido.titulo}>
                <h2 style={estiloTitulo} id="OrcamentoConcluido_Titulo">
                    Orçamento Concluído
                </h2>
            </div>

            <div className={estiloOrcamentoConcluido.itensVerficados}>
                <p id="OrcamentoConcluido_NumeroOrcamento">
                    <FontAwesomeIcon style={estiloIcone} icon={faCircleCheck} />
                    {"Nº do Orçamento: "}
                    <TooltipMU title="Clique para editar o orçamento">
                        <a 
                            href="#" 
                            onClick={handleClickNumeroOrc}
                            id="OrcamentoConcluido_LinkNumeroOrcamento"
                        >
                            {props.numero}
                        </a>
                    </TooltipMU>
                </p>

                <p id="OrcamentoConcluido_Situacao">
                    <FontAwesomeIcon style={estiloIcone} icon={faCircleCheck} />
                    {"Situação: "}{props.descricaoSituacao}
                </p>

                {props.numeroDav && (
                    <p 
                        id="OrcamentoConcluido_NumeroDav"
                        title="Veja parâmetros: &#013;- Utiliza numeração paralela no orçamento para o DAV&#013;- Trabalha com ECF Nacional&#013;- Versão PAF/ECF"
                    >
                        <FontAwesomeIcon style={estiloIcone} icon={faCircleCheck} />
                        {"Nº do DAV: "}{props.numeroDav}
                    </p>
                )}
            </div>

            {props.aptoParaCheckoutMovel && (
                <div 
                    className={estiloOrcamentoConcluido.aptoParaCheckoutMovel}
                    id="OrcamentoConcluido_AptoCheckoutMovel"
                >
                    <span>Orçamento poderá ser faturado pelo Checkout Móvel</span>
                </div>
            )}

            <div className={estiloOrcamentoConcluido.botoes}>
                {props.permitidoImprimir && (
                    <button
                        type="button"
                        id="OrcamentoConcluido_ImprimirOrcamento"
                        title="Veja parâmetro:&#013;-Bloquear impressão de orçamento pendente&#013;-Solicitar senha de autorização na impressão de orçamentos com desconto acima do permitido"
                        className={estiloOrcamentoConcluido.botao}
                        onClick={props.onImprimirOrcamento}
                        disabled={props.processando}
                    >
                        Imprimir Orçamento
                    </button>
                )}

                <button
                    type="button"
                    id="OrcamentoConcluido_NovoOrcamento"
                    className={estiloOrcamentoConcluido.botao}
                    onClick={handleNovoOrcamento}
                    disabled={props.processando}
                >
                    Novo Orçamento
                </button>
            </div>
        </div>
    )
})
